<script setup>

import NumberOnlyInput from "@/components/common/input/NumberOnlyInput"
import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown"
import Button from "@/components/common/input/Button"
import MovingTooltip from "@/components/common/other/MovingTooltip"
import PurchaseOrderStatusExtended from "@/classes/component-classes/PurchaseOrderStatusExtended";
import PurchaseOrderStatus from "@/classes/component-classes/PurchaseOrderStatus";
import DateInput from "@/components/common/input/DateInput";

import {useGetValidatedFields} from "@/composables/common/useGetValidatedFields";

import {ref, onMounted, nextTick, inject, computed} from 'vue';
import {useStore} from "vuex";

const store = useStore();
const localArray = ref([]);

const emits = defineEmits(['entry-update'])

const props = defineProps({

  modelValue: {
    type: Array, default: function () {
      return []
    },
  },

  requiredFields: {type: Array, default: []},
  validationFail: Boolean,
  height: Number

})

onMounted(() => {

  // Set memory reference from local data
  let orderStats = localArray.value

  props.modelValue.forEach(function (item) {

    // Cast the pure model class into the local extended class
    let orderStatus = {...new PurchaseOrderStatusExtended(), ...item}

    // Set all correct props for returning data for button actions
    orderStatus.showAddButton = false;
    orderStatus.readOnly = true;

    orderStats.push(orderStatus)
  })

  // Add a new empty line after the current one
  orderStats.push(new PurchaseOrderStatusExtended())

})

function addNewItem(line, index) {

  let valid = validate(line);

  if (valid) {

    line.showAddButton = false;
    line.readOnly = true;

    localArray.value.push(new PurchaseOrderStatusExtended());
    props.modelValue.push(new PurchaseOrderStatus());

    modelValueUpdate(line, index);

  }

}

function validate(line) {

  // if(!line.containerType || !line.teu || !line.containerNumber || !line.sealNumber) return false;

  return true;

}

function modelValueUpdate(line, index) {

  // Collect the pure model keys and update the values from the current local line
  for (const propName in props.modelValue[0]) {
    props.modelValue[index][propName] = line[propName]
  }

}

function prepareDelete(line) {
  line.isDeleting = true;
}

function cancelDelete(line) {
  line.isDeleting = false;
}

function removeItem(index, line) {

  localArray.value.splice(index, 1);
  props.modelValue.splice(index, 1);

  localArray.value[localArray.value.length - 1].isEditing = false;
  localArray.value[localArray.value.length - 1].readOnly = false;

}

function editItem(line) {

  localArray.value.forEach(item => {
    item.readOnly = true;
  });

  line.readOnly = false;
  line.isEditing = true;

  // Take the add button away if editing a line
  localArray.value[localArray.value.length - 1].isEditing = true;

}

function acceptEdit(line, index) {

  let valid = validate(line)

  if (valid) {

    if (index === localArray.value.length - 1) {
      props.modelValue.push(new PurchaseOrderItemDetail())
    }

    modelValueUpdate(line, index);

    line.readOnly = true;
    localArray.value[localArray.value.length - 1].isEditing = false;
    localArray.value[localArray.value.length - 1].readOnly = false;
  }

}



</script>

<template>
  <div class="cmp-purchase-order-status">
    <div class="cmp-purchase-order-status_labels">
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'productCode')}">Status Code</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'productDescription')}">Status Text</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'qtyRequired')}">User</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'qtyReceived')}">Date</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'qtyRemaining')}">Comment</div>
    </div>
    <div class="cmp-purchase-order-status_container" :style="{ height: props.height + 'px' }">
      <div v-for="(line, index) in localArray" class="cmp-purchase-order-status_wrapper" :key="index">
        <TextInput
            v-model="line.statusCode"
            :width="230">
        </TextInput>
        <TextInput
            v-model="line.statusText"
            :width="410">
        </TextInput>
        <TextInput
            v-model="line.user"
            :width="380">
        </TextInput>
        <DateInput
            v-model="line.date"
            style="margin-right: 30px"
            :width="130">
          <el-date-picker
              v-model="line.date"
              :clearable="false"
              value-format="DD-MMM-YY"/>
        </DateInput>
        <TextInput
            v-model="line.comment"
            :width="460">
        </TextInput>

        <div v-if="line.showAddButton && !line.isEditing" class="cmp-purchase-order-status_icons" title="Add New Line">
          <!--          <Button type="toolbar" text="Add" @on-click="addContainer(line, index)"></Button>-->
          <i @click="addNewItem(line, index)" class="fa-solid fa-circle-plus" style="color: #3f9968"></i>
        </div>
        <div v-if="line.readOnly && !line.isDeleting" class="cmp-purchase-order-status_icons" title="Edit Line">
          <!--          <Button type="success" text="Edit" @on-click="editContainer(line)"></Button>-->
          <i @click="editItem(line)" class="fa-solid fa-pen-to-square" style="color: #37798a"></i>
        </div>
        <div v-if="line.isDeleting" class="cmp-purchase-order-status_icons" title="Confirm Delete">
          <!--          <Button type="info" text="Yes" @on-click="removeContainer(index, line)"></Button>-->
          <i @click="removeItem(index, line)" class="fa-solid fa-solid fa-trash-check" style="color: #b0752a"></i>
        </div>
        <div v-if="!line.readOnly && line.isEditing && !line.isDeleting" class="cmp-purchase-order-status_icons" title="Accept Changes">
          <!--          <Button type="secondary" text="Accept" @on-click="acceptEdit(line, index)"></Button>-->
          <i @click="acceptEdit(line, index)" class="fa-solid fa-circle-check" style="color: #3f9968"></i>
        </div>
        <div v-if="!line.showAddButton && !line.isDeleting" class="cmp-purchase-order-status_icons" title="Delete">
          <!--          <Button type="danger" text="Delete" @on-click="prepareDelete(line)"></Button>-->
          <i  @click="prepareDelete(line)" class="fa-solid fa-trash" style="color: #832222"></i>
        </div>
        <div v-if="line.isDeleting" class="cmp-purchase-order-status_icons" title="Do Not Delete">
          <!--          <Button type="secondary" text="No" @on-click="cancelDelete(line)"></Button>-->
          <i @click="cancelDelete(line)" class="fa-solid fa-ban" style="color: #832222;"></i>
        </div>
      </div>
    </div>
  </div>

</template>


<style lang="scss" scoped>

.cmp-purchase-order-status {

  &_wrapper {
    width: 940px;
    display: flex;
    gap: 4px;
  }

  &_wrapper > div {
    margin-bottom: 3px;
  }

  &_container {
    //height: 60px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &_labels {
    margin-bottom: 3px;
    display: grid;
    grid-template-columns: 229px 408px 378px 148px 155px;
    gap: 6px;
  }

  &_labels div {
    color: #454545;
    font-weight: bold;
    font-size: 12px;
    display: flex;
  }

  &_icons {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 20px;
    margin-left: 10px;
  }

}

</style>
